import React, { useMemo, useState } from 'react';
import ProfilePic from '../../components/profilepic/ProfilePic';
import searchIcon from '../../assets/ic_search.svg';

const ONLINE_WINDOW_MS = 5 * 60 * 1000;

const friendStatus = (friend) => {
    const last = friend?.lastWatchedTime ? new Date(friend.lastWatchedTime).getTime() : 0;
    if (!last) return { label: 'Открыть профиль', online: false };
    const diff = Date.now() - last;
    if (diff <= ONLINE_WINDOW_MS) return { label: 'Сейчас смотрит', online: true };
    const days = Math.floor(diff / 86_400_000);
    if (days === 0) return { label: 'Был(а) сегодня', online: false };
    if (days === 1) return { label: 'Был(а) вчера', online: false };
    if (days < 7) return { label: `Был(а) ${days} дн. назад`, online: false };
    return { label: 'Давно не заходил(а)', online: false };
};

const FriendsPopup = ({ friends = [], closePopup }) => {
    const [query, setQuery] = useState('');
    const filteredFriends = useMemo(() => {
        const normalizedQuery = query.trim().toLocaleLowerCase('ru');
        if (!normalizedQuery) return friends;
        return friends.filter((friend) => friend.nickname?.toLocaleLowerCase('ru').includes(normalizedQuery));
    }, [friends, query]);

    return (
        <div className="fr-popup-container" onMouseDown={(event) => {
            if (event.target === event.currentTarget) closePopup();
        }}>
            <section className="fr-popup" role="dialog" aria-modal="true" aria-labelledby="friends-popup-title">
                <header className="fr-popup__header">
                    <div>
                        <h2 id="friends-popup-title">Друзья</h2>
                        <p>{friends.length} в списке</p>
                    </div>
                    <button className="ui-close" type="button" onClick={closePopup} aria-label="Закрыть">
                        ×
                    </button>
                </header>

                {friends.length > 0 ? (
                    <label className="fr-popup__search">
                        <img src={searchIcon} alt="" aria-hidden="true" />
                        <input
                            type="search"
                            value={query}
                            onChange={(event) => setQuery(event.target.value)}
                            placeholder="Найти друга"
                            aria-label="Найти друга"
                            autoFocus
                        />
                    </label>
                ) : null}

                <div className="fr-friends-list">
                    {filteredFriends.length > 0 ? filteredFriends.map((friend) => {
                        const status = friendStatus(friend);
                        return (
                        <a className="fr-friend-item" key={friend.id || friend.nickname} href={`/profile/${friend.nickname}`}>
                            <ProfilePic isBig={false} account={friend} />
                            <span className="fr-friend-details">
                                <strong>{friend.nickname}</strong>
                                <small className={`fr-friend-status${status.online ? ' is-online' : ''}`}>{status.label}</small>
                            </span>
                            <span className="fr-friend-item__arrow" aria-hidden="true">›</span>
                        </a>
                        );
                    }) : (
                        <div className="fr-popup__empty">
                            <span aria-hidden="true">☻</span>
                            <p>{friends.length > 0 ? 'Никого не нашли' : 'Здесь пока нет друзей'}</p>
                        </div>
                    )}
                </div>
            </section>
        </div>
    );
};

export default FriendsPopup;
